/**
 * @fileoverview Servicio para gestión de cursos
 * @description Maneja todas las peticiones HTTP relacionadas con cursos
 */

import { API_BASE_URL, defaultConfig, handleResponse, buildApiUrl, API_ENDPOINTS } from '../config/api';

/**
 * Servicio para gestión de cursos
 */
export const cursoService = {
  /**
   * Crea un nuevo curso
   * @param data - Datos del curso
   * @returns Promise con la respuesta del servidor
   */
  async crearCurso(data: any) {
    const response = await fetch(buildApiUrl(API_ENDPOINTS.CURSO), {
      method: 'POST',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  },

  /**
   * Obtiene un curso por ID
   * @param id - ID del curso
   * @returns Promise con los datos del curso
   */
  async obtenerCurso(id: number) {
    const response = await fetch(`${API_BASE_URL}/formulario/curso/${id}`, {
      method: 'GET',
      ...defaultConfig,
    });
    return handleResponse(response);
  },

  /**
   * Actualiza un curso existente
   * @param id - ID del curso
   * @param data - Datos actualizados
   * @returns Promise con la respuesta del servidor
   */
  async actualizarCurso(id: number, data: any) {
    const response = await fetch(`${API_BASE_URL}/formulario/curso/update/${id}`, {
      method: 'PUT',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  },

  /**
   * Elimina un curso
   * @param id - ID del curso
   * @returns Promise con la respuesta del servidor
   */
  async eliminarCurso(id: number) {
    const response = await fetch(`${API_BASE_URL}/formulario/curso/${id}`, {
      method: 'DELETE',
      ...defaultConfig,
    });
    return handleResponse(response);
  }
};
